import WidgetsMgr from 'widgets/widgetsMgr';
import ApplePayExpress from './widgets/checkout/ApplePayExpress';

WidgetsMgr.addWidgetsList('adyen.applepay.express', () => [['applePayExpress', ApplePayExpress]]);

const hasContext = (context: string) => window.contexts.includes(context);
const hasContexts = (contexts: Array<string>) => contexts.every(context => window.contexts.includes(context));

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('checkout'),
    load: () =>
        Promise.all([import('./widgets/checkout/ApplePay').then(d => d.default)]).then(deps => {
            const [ApplePay] = deps;

            return {
                listId: 'adyen.applepay',
                widgetsDefinition: () => [['applePay', ApplePay]]
            };
        })
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContext('pdp') || hasContext('cart') || hasContext('checkout'),
    load: () =>
        Promise.all([import(/* webpackChunkName: 'express.payments.widgets' */ './widgets/checkout/GooglePayExpress').then(d => d.default)]).then(
            deps => {
                const [GooglePayExpress] = deps;

                return {
                    listId: 'adyen.express.payments.widgets',
                    widgetsDefinition: () => [['googlePayExpress', GooglePayExpress]]
                };
            }
        )
});

WidgetsMgr.asyncLists.push({
    getLoadingFlag: () => hasContexts(['checkout', 'adyen']),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: 'checkout.adyen' */ './widgets/checkout/ExtAdyenPaymentAccordion').then(d => d.default),
            import(/* webpackChunkName: 'checkout.adyen' */ './widgets/checkout/ExtAdyenSummaryCheckoutMixin').then(d => d.default),
            import(/* webpackChunkName: 'checkout.adyen' */ './widgets/checkout/ExtPaymentAccordionItemAdyenComponent').then(d => d.default),
            import(/* webpackChunkName: 'checkout.adyen' */ './widgets/checkout/PaymentAccordionItemAdyenGooglePay').then(d => d.default)
        ]).then(deps => {
            const [
                ExtAdyenPaymentAccordion,
                ExtAdyenSummaryCheckoutMixin,
                ExtPaymentAccordionItemAdyenComponent,
                PaymentAccordionItemAdyenGooglePay
            ] = deps;

            return {
                listId: 'checkout.adyen.ext',
                widgetsDefinition: () => [
                    ['checkoutMgr', ExtAdyenSummaryCheckoutMixin, 'checkoutMgr'],
                    // accordion / paymentAccordion
                    ['paymentAccordion', ExtAdyenPaymentAccordion, 'paymentAccordion'],
                    ['paymentAccordionItemAdyenComponent', ExtPaymentAccordionItemAdyenComponent, 'paymentAccordionItemAdyenComponent'],
                    ['paymentAccordionItemAdyenGooglePay', PaymentAccordionItemAdyenGooglePay, 'paymentAccordionItemAdyenComponent']
                ]
            };
        })
});
